<template>
    <div class="Main_lang" @click="changeEnd" v-if="getCurrentLang()">
        <div class="Main_lang_item" :class="getCurrentLang() == 'zh' ? 'active' : ''">中</div>
        <div class="Main_lang_item" :class="getCurrentLang() == 'en' ? 'active_en' : ''">{{ eventId ==
            '2149' ? 'Ru' : 'En'}}</div>
    </div>
</template>

<script>
import { setLocale } from '../../lang';
import { getCurrentLang } from '@/lang/utils/i18n-util';
import { getCanonicalPath, getRouteEventId } from '@/utils/route';
export default {
    props: {
        switchColor: {
            type: String,
            default: '#373AB5',
        },
    },
    name: "App",
    data() {
        return {
            event_id: "",
        };
    },

    async mounted() {
        this.event_id = getRouteEventId(this.$route);
        if (this.switchColor) {
            const root = document.documentElement;
            root.style.setProperty("--color1", this.switchColor);
        }
    },
    methods: {
        getCurrentLang,
        changeEnd() {
            const newLang = getCurrentLang() == 'zh' ? 'en' : 'zh';
            setLocale(newLang);
            sessionStorage.microSiteEditLang = newLang;
            // 切换语言后统一回到首页：两种语言的内容页并非一一对应，停留在原页面可能无对应内容
            this.$router.push(getCanonicalPath(
                { ...this.$route, params: { ...this.$route.params, lang: newLang, event_id: this.eventId } },
                '/'
            )).then(() => {
                location.reload();
            });
        },
    },
    computed: {
        eventId() {
            return String(this.event_id || getRouteEventId(this.$route));
        },
    },

    destroyed() {
    },
};
</script>
<style lang="scss" scoped>
.Main_lang {
    position: absolute;
    top: 5px;
    right: 40px;
    width: 105px;
    height: 32px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid var(--color1);
    display: flex;
    align-items: center;
    z-index: 10000;

    .Main_lang_item {
        flex: 1;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 17px;
        color: var(--color1);
        text-align: center;
        height: 36px;
        line-height: 36px;
        cursor: pointer;
    }

    .active,
    .active_en {
        background-color: var(--color1);
        position: relative;
        color: #ffffff;
        border-radius: 3px 0 0 3px;
        margin-left: -2px;

        &:after {
            content: "";
            position: absolute;
            top: 0;
            right: -10px;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 0 36px 10px;
            border-color: transparent transparent var(--color1) transparent;
            z-index: 2;
            transform: rotate(180deg);
        }
    }

    .active_en {
        border-radius: 0 3px 3px 0;
        margin-right: -2px;

        &:after {
            content: "";
            position: absolute;
            top: 0;
            left: -10px;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 0 36px 10px;
            border-color: transparent transparent var(--color1) transparent;
            z-index: 2;
            transform: rotate(0deg);
        }
    }
}

@media screen and (max-width: 700px) {
    .Main_lang {
        transform: scale(0.6);
        top: 6px;
        right: -6px;
    }
}

@media screen and (max-width: 600px) {
    .Main_lang {
        transform: scale(0.5);
        top: 4px;
        right: -6px;
    }
}

@media screen and (max-width: 500px) {
    .Main_lang {
        transform: scale(0.5);
        top: -2px;
        right: -8px;
    }
}

@media screen and (max-width: 400px) {
    .Main_lang {
        transform: scale(0.32);
        top: -4px;
        right: -16px;
    }
}
</style>
